import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useRouteRef } from '@backstage/frontend-plugin-api';
import { homeRouteRef } from '../home/routeRef';
import { useAdminCheck } from '../home/useIsAdmin';

/**
 * The catalog index for the admin tier only: everyone else is sent to the
 * home page (« Projets »), which lists their projects.
 *
 * UX, NOT SECURITY. The index is only a screen; the catalog API stays
 * reachable and the permission policy
 * (plugins/waadoo-core-backend/src/extensions/permissionsPolicyExtension.ts) still
 * decides what any caller can read.
 *
 * Nothing is rendered while the admin check is pending, so a non-admin never
 * sees the index flash before the redirect. A failed check redirects too —
 * fail closed, like the sidebar entry (`useIsAdmin.ts`).
 */
export function AdminOnlyCatalogIndex(props: { children: ReactNode }) {
  const check = useAdminCheck();
  // Undefined only when the home plugin is not registered: then there is no
  // page to send anyone to, and nothing is shown.
  const homeRoute = useRouteRef(homeRouteRef);

  if (check === 'pending') {
    return null;
  }
  if (check === 'admin') {
    return <>{props.children}</>;
  }
  return homeRoute ? <Navigate to={homeRoute()} replace /> : null;
}
